import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import { API_Version_LIST, ListId, EntryId } from './endPointConstants';

export const getListsByType: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const createListsObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const updateListsObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists`,
  method: HTTPVerbs.PATCH,
  retries: 0,
};

export const deleteListObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists/${ListId}`,
  method: HTTPVerbs.DELETE,
  retries: 0,
};

export const addToListsObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists/entries`,
  method: HTTPVerbs.POST,
  retries: 0,
};
export const getListReqObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists/${ListId}`,
  method: HTTPVerbs.GET,
  retries: 0,
};
export const removeEntryListReqObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists/${ListId}/entries/${EntryId}`,
  method: HTTPVerbs.DELETE,
};
export const changeListEntryReqObj: RequestOptions = {
  url: `/comlistas/${API_Version_LIST}/lists/${ListId}/entries/${EntryId}`,
  method: HTTPVerbs.PATCH,
};
